import React, { useState, useEffect, useCallback } from "react";
import { Select, MenuItem, SelectChangeEvent } from "@mui/material";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/yapa-logo.png";
import { getConcerts, getConcertYears } from "../AddingConcert/ConcertApi";
import "./ConcertList.css";

interface Concert {
  idKoncertu: number;
  miejsceKoncertu: string;
  dataKoncertu: string;
  godzinaRozpoczecia: string;
  Prowadzacy: string;
}

const ConcertList = () => {

  const DEFAULT_YEAR = new Date().getFullYear().toString();

  const [concerts, setConcerts] = useState<Concert[]>([]);
  const [filteredConcerts, setFilteredConcerts] = useState<Concert[]>([]);
  const [years, setYears] = useState<string[]>([]);
  const [selectedYear, setSelectedYear] = useState<string>(DEFAULT_YEAR);

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  // Pobierz dane koncertów
  const fetchConcerts = useCallback(async () => {
    try {
      await getConcerts(axiosPrivate, setConcerts);
    } catch (error) {
      console.error("Błąd podczas pobierania koncertów:", error);
    }
  }, [axiosPrivate]);

  useEffect(() => {
    fetchConcerts();
  }, [fetchConcerts]);

  useEffect(() => {
    getConcertYears(axiosPrivate, setYears);
  }, [axiosPrivate]);

  useEffect(() => {
    if (selectedYear) {
      setFilteredConcerts(
        concerts.filter((concert) => {
          const parts = concert.dataKoncertu.split('-'); // ["DD", "MM", "YYYY"]
          const concertYear = parts[2]; 
          return concertYear === selectedYear;
        })
      );
    } else {
      setFilteredConcerts(concerts);
    }
  }, [selectedYear, concerts]);

  const handleRowClick = (id: number) => {
    navigate(`/concert/${id}`);
  };
  
  const handleEditClick = (id: number) => {
    console.log("Kliknięto edycję dla ID:", id);
    navigate(`/concertEdit/${id}`);
  };
  
  const handleYearChange = (event: SelectChangeEvent) => {
    setSelectedYear(event.target.value);
  };

  const handleDelete = async (id: number) => {
    const confirmDelete = window.confirm("Czy na pewno chcesz usunąć ten koncert?");
    if (confirmDelete) {
      try {
        await axiosPrivate.delete(`/concerts/${id}`); 
        alert("Koncert został pomyślnie usunięty.");
        fetchConcerts(); 
      } catch (error) {
        console.error("Błąd podczas usuwania koncertu:", error);
        alert("Wystąpił błąd podczas usuwania koncertu.");
      }
    }
  };
  const concertsListOnClick1 = () => {
    navigate('/concertAdd');
  }

  return (
    <div className="concerts-container">
      <div>
        <img src={logo} alt="Yapa Logo" className="logo" />
        <div className="header-filters-concerts">
          <h1>KONCERTY</h1>
          <div className="filters">
            <Select
              value={years.includes(selectedYear) ? selectedYear : DEFAULT_YEAR}
              onChange={handleYearChange}
              displayEmpty
              className="filter-select-bands"
              sx={{
                backgroundColor: "#222222",
                border: "1px solid #ff8800",
                color: "#ffffff",
                "& .MuiSelect-icon": { color: "#ff8800" },
                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
              }}
            >
            {years.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
            </Select>
          </div>
        </div>

        <div className="table-concerts-actions-container">
          <div className="table-concerts-container">
            <table className="concerts-table">
              <thead>
                <tr>
                  <th>Nazwa koncertu</th>
                  <th>Prowadzący</th>
                  <th>
                    <span className="desktop-header">Godzina rozpoczęcia</span>
                    <span className="mobile-header">Start</span>
                  </th>
                  <th>Data</th>
                  <th>
                    <span className="desktop-header">Edycja i usuwanie</span>
                    <span className="mobile-header">Edycja</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredConcerts.map((concert, index) => (
                  <tr
                    key={concert.idKoncertu}
                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                    onClick={() => handleRowClick(concert.idKoncertu)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{concert.miejsceKoncertu}</td>
                    <td>{concert.Prowadzacy}</td>
                    <td>{concert.godzinaRozpoczecia}</td>
                    <td>{concert.dataKoncertu}</td>
                    <td>
                      <button
                        className="btn icon-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditClick(concert.idKoncertu);
                        }}
                      >
                        ✏️
                      </button>
                      <button
                        className="btn icon-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(concert.idKoncertu);
                        }}
                        disabled={concert.idKoncertu === 1}
                        style={{
                          opacity: concert.idKoncertu === 1 ? 0.5 : 1,
                          cursor: concert.idKoncertu === 1 ? 'not-allowed' : 'pointer'
                        }}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="concerts-actions">
            <button className="btn" onClick={(concertsListOnClick1)}>
              Dodaj
            </button>
            <button className="btn" onClick={() => navigate(-1)}>
              Wróć
            </button>
          </div>
        </div>
      </div>
    </div>

  );
};

export default ConcertList;